import ItemForm from "../components/itemForm";


const EditItem = () => {
  return <ItemForm isEdit={true} />;
};

export default EditItem;